import React, { useState }  from 'react';
import portfolioSections from '../data/portfolioData.json';
import './Portfolio.css';

const Portfolio = () => {
    const [scrollingSection, setScrollingSection] = useState(null);
  return (
    <div className="portfolio-bg-wrapper">
    <div className="portfolio-container">
      {portfolioSections.map((section, idx) => {
        const itemsToShow = section.items;
        return (
          <div key={idx} className="portfolio-section">
            <h2 className="section-title">{section.category}</h2>
            <div
  className="scroll-wrapper"
  onMouseEnter={() => setScrollingSection(idx)}
  onMouseLeave={() => setScrollingSection(null)}
>
  <div
    className={`scroll-track ${
      scrollingSection === idx ? 'scrolling' : ''
    }`}
  >
    {[...itemsToShow, ...itemsToShow].map((item, itemIdx) => (
      <div className="portfolio-item" key={itemIdx}>
        <img
          src={`${process.env.PUBLIC_URL}/images/portfolio/${item.image}`}
          alt={item.title}
          className="portfolio-image"
        />
        <h4 className="portfolio-title">{item.title}</h4>
        <p className="portfolio-desc">{item.description}</p>
      </div>
    ))}
  </div>
</div>
            {/* <div
              className="scroll-wrapper"
              onMouseEnter={() => setScrollingSection(idx)}
              onMouseLeave={() => setScrollingSection(null)}
            >
              <div
                className={`scroll-track ${
                  scrollingSection === idx ? 'scrolling' : ''
                }`}
              >
                {[...itemsToShow, ...itemsToShow].map((item, itemIdx) => (
                  <div className="portfolio-item" key={itemIdx}>
                    <img
                      src={process.env.PUBLIC_URL + `/images/portfolio/${item.image}`}
                      alt={item.title}
                      className="portfolio-image"
                    />
                    <h4 className="portfolio-title">{item.title}</h4>
                    <p className="portfolio-desc">{item.description}</p>
                  </div>
                ))}
              </div>
            </div> */}
          </div>
        );
      })}
    </div>
    </div>
  );
};

export default Portfolio;